export default "__VITE_ASSET__Dh0IRYLj__"